export default "__VITE_ASSET__CHfgJoB3__"